(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lz-pvc-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-lz-pvc-cta-scroll]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = document.querySelector('[data-lz-pvc] .lz-pvc__order');
    if (!target) return;
    event.preventDefault();
    var section = link.closest('.lz-pvc-cta');
    var offset = Number(section.dataset.headerOffset) || 0;
    var top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top: top, behavior: reduceMotion ? 'instant' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-pvc-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (!root || root.dataset.pvcReady) return;
    root.dataset.pvcReady = 'true';
    const form = root.querySelector('form');
    const variants = JSON.parse(root.querySelector('[data-pvc-variants]').textContent);
    const variantInput = root.querySelector('[data-pvc-variant]');
    const quantity = root.querySelector('[data-pvc-quantity]');
    const file = root.querySelector('[data-pvc-file]');
    const later = root.querySelector('[data-pvc-later]');
    const error = root.querySelector('[data-pvc-error]');
    const add = root.querySelector('[data-pvc-add]');
    const addLabel = root.querySelector('[data-pvc-add-label]');
    const remove = root.querySelector('[data-pvc-remove]');
    const money = cents => new Intl.NumberFormat('bg-BG', {style:'currency',currency:root.dataset.currency,minimumFractionDigits:2,maximumFractionDigits:2}).format(cents / 100);
    let busy = false;
    let active = variants.find(v => String(v.id) === variantInput.value) || variants[0];
    function showError(message) {error.textContent=message;error.hidden=!message;}
    function readQuantity() {return Math.min(100,Math.max(1,Math.floor(Number(quantity.value)||1)));}
    function updateDimensions() {
      const note = root.querySelector('[data-pvc-dimensions]');
      const output = root.querySelector('[data-pvc-print-size]');
      if (!note) return;
      if (!active) {note.textContent='Избери валидна комбинация.';if(output){output.value='';output.disabled=true;}return;}
      const shapePosition = Number(root.dataset.shapeOptionPosition || 0);
      if (!shapePosition) {note.textContent='Максимален габарит: '+String(active.option1 || '').replace(/[хx]/g,'×')+'. Запазваме пропорциите на дизайна.';return;}
      const selected = root.querySelector('[data-pvc-shape]:checked');
      const size = Number(String(active.option1 || '').match(/\d+/)?.[0]);
      if (!selected || !size) {if(output){output.value='';output.disabled=true;}return;}
      const height = {50:30,60:40,70:50,80:60,90:60,100:70,120:80,150:100}[size];
      let exact;
      if (selected.dataset.pvcShape === 'circle') exact='Ø '+size+' мм';
      else if (selected.dataset.pvcShape === 'square') exact=size+'×'+size+' мм';
      else if (selected.dataset.pvcShape === 'rectangle' && height) exact=size+'×'+height+' мм';
      else exact='До '+size+'×'+size+' мм, според пропорциите на дизайна';
      note.textContent='Размер за печат: '+exact+(selected.dataset.pvcShape==='rectangle'?' (ширина × височина).':'.');
      if(output){output.value=exact;output.disabled=false;}
    }
    function update() {
      const values = [...root.querySelectorAll('[data-pvc-option]')].map(group => group.querySelector('input:checked')?.value);
      active = variants.find(v => v.options.every((value,index) => value===values[index])) || (values.length ? null : variants[0]);
      quantity.value=readQuantity();
      updateDimensions();
      if (!active) {add.disabled=true;addLabel.textContent='НЕДОСТЪПНА КОМБИНАЦИЯ';variantInput.value='';return;}
      variantInput.value=String(active.id);
      const count = Number(String(active.option2 || '').match(/\d+/)?.[0]) || 1;
      root.querySelector('[data-pvc-price]').textContent=money(active.price);
      root.querySelector('[data-pvc-unit]').textContent=money(active.price/count)+' / бр.';
      root.querySelector('[data-pvc-price-note]').textContent=count+' стикера в един пакет';
      root.querySelector('[data-pvc-total-count]').textContent=(count*readQuantity())+' стикера общо';
      root.querySelector('[data-pvc-total]').textContent=money(active.price*readQuantity());
      add.disabled=busy || !active.available;
      addLabel.textContent=busy?'ДОБАВЯНЕ…':active.available?'ДОБАВИ В КОЛИЧКАТА':'ИЗЧЕРПАНО';
    }
    root.querySelectorAll('[data-pvc-option] input').forEach(input => input.addEventListener('change',() => {
      showError('');update();
      if (active) {const url=new URL(location.href);url.searchParams.set('variant',active.id);history.replaceState({},'',url);}
    }));
    quantity.addEventListener('change',update);
    root.querySelector('[data-pvc-minus]').addEventListener('click',() => {quantity.value=readQuantity()-1;update();});
    root.querySelector('[data-pvc-plus]').addEventListener('click',() => {quantity.value=readQuantity()+1;update();});
    function resetFile() {file.value='';root.querySelector('[data-pvc-file-label]').textContent='Качи лого или готов дизайн';remove.hidden=true;}
    remove.addEventListener('click',() => {resetFile();showError('');});
    file.addEventListener('change',() => {
      showError('');const selected=file.files[0];
      if (!selected) {resetFile();return;}
      if (!/\.(pdf|png|jpe?g)$/i.test(selected.name)) {resetFile();showError('Избери PDF, PNG или JPG файл.');return;}
      if (selected.size>20*1024*1024) {resetFile();showError('Файлът е по-голям от 20 MB. Изпрати го по имейл след поръчката.');return;}
      later.checked=false;root.querySelector('[data-pvc-email]').hidden=true;
      root.querySelector('[data-pvc-file-label]').textContent=selected.name;remove.hidden=false;
    });
    later.addEventListener('change',() => {showError('');root.querySelector('[data-pvc-email]').hidden=!later.checked;if(later.checked)resetFile();});
    function updateShapePhoto() {
      const selected = root.querySelector('[data-pvc-shape]:checked');
      if (!selected) return;
      const photo = [...root.querySelectorAll('[data-pvc-shape-slide]')].find(slide => slide.dataset.pvcShapeSlide === selected.dataset.pvcShape);
      const productSlides = [...root.querySelectorAll('[data-pvc-slide]')];
      root.querySelectorAll('[data-pvc-shape-slide]').forEach(slide => {slide.hidden = slide !== photo;});
      productSlides.forEach((slide,index) => {slide.hidden = Boolean(photo) || index !== 0;});
      root.querySelectorAll('[data-pvc-thumb]').forEach((button,index) => button.setAttribute('aria-pressed',String(!photo && index === 0)));
      const placeholder = root.querySelector('[data-pvc-placeholder]');
      if (placeholder) placeholder.hidden = Boolean(photo);
    }
    root.querySelectorAll('[data-pvc-shape]').forEach(input => input.addEventListener('change',updateShapePhoto));
    root.querySelectorAll('[data-pvc-thumb]').forEach(button => button.addEventListener('click',() => {
      root.querySelectorAll('[data-pvc-shape-slide]').forEach(slide => {slide.hidden=true;});
      root.querySelectorAll('[data-pvc-slide]').forEach(slide => slide.hidden=slide.dataset.pvcSlide!==button.dataset.pvcThumb);
      root.querySelectorAll('[data-pvc-thumb]').forEach(other => other.setAttribute('aria-pressed',String(other===button)));
    }));
    form.addEventListener('submit',event => {
      event.preventDefault();event.stopImmediatePropagation();
      if (busy) return;
      showError('');update();
      if (!active?.available) return;
      if (!file.files.length && !later.checked) {showError('Качи дизайн или избери „Ще изпратя дизайна след поръчката“.');file.focus();return;}
      if(!form.reportValidity())return;
      busy=true;form.setAttribute('aria-busy','true');update();
      try {
        HTMLFormElement.prototype.submit.call(form);
      } catch(reason) {
        busy=false;form.removeAttribute('aria-busy');update();
        showError('Не успяхме да изпратим поръчката към количката. Презареди страницата и опитай отново.');
      }
    },true);
    window.addEventListener('pageshow',() => {busy=false;form.removeAttribute('aria-busy');update();updateShapePhoto();});
    update();
    updateShapePhoto();
  }
  document.querySelectorAll('[data-lz-pvc]').forEach(initialize);
  document.addEventListener('shopify:section:load',event => initialize(event.target.querySelector('[data-lz-pvc]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lz-sticker-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const media = root.querySelector('[data-peel-media]');
      const panel = root.querySelector('.lz-sticker-hero__panel');
      const compareRange = root.querySelector('[data-compare-range]');
      const hint = root.querySelector('[data-peel-hint]');
      const roomButtons = [...root.querySelectorAll('[data-room-button]')];
      const roomPairs = [...root.querySelectorAll('[data-room-pair]')];
      const initialReveal = Number(root.dataset.initialReveal || 52);
      let currentReveal = initialReveal;
      let compareMaximum = 95;

      const setReveal = (value) => {
        const reveal = Math.min(compareMaximum, Math.max(5, Number(value)));
        currentReveal = reveal;
        media?.style.setProperty('--reveal', `${reveal}%`);
        compareRange?.setAttribute('aria-valuenow', String(Math.round(reveal)));
      };

      const activateRoom = (room) => {
        roomPairs.forEach((pair) => {
          pair.hidden = pair.dataset.roomPair !== room;
        });

        roomButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.roomButton === room));
        });

        setReveal(initialReveal);
        media?.classList.remove('is-used');
        hint?.classList.remove('is-hidden');
      };

      roomButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.getAttribute('aria-pressed') === 'true') return;
          activateRoom(button.dataset.roomButton);
        });
      });

      const syncCompareBounds = (useCurrentValue = true) => {
        if (!media || !compareRange) return;

        compareMaximum = 95;
        if (panel && window.innerWidth >= 768) {
          const mediaRect = media.getBoundingClientRect();
          const panelRect = panel.getBoundingClientRect();
          const panelStart = ((panelRect.left - mediaRect.left) / mediaRect.width) * 100;
          compareMaximum = Math.min(95, Math.max(45, panelStart - 2));
        }

        compareRange.setAttribute('aria-valuemax', String(Math.round(compareMaximum)));
        setReveal(useCurrentValue ? currentReveal : initialReveal);
      };

      if (media && compareRange) {
        syncCompareBounds(false);

        let isDragging = false;
        let dragStartX = 0;
        let dragStartReveal = currentReveal;

        const markCompareUsed = () => {
          media.classList.add('is-used');
          hint?.classList.add('is-hidden');
        };

        compareRange.addEventListener('pointerdown', (event) => {
          isDragging = true;
          dragStartX = event.clientX;
          dragStartReveal = currentReveal;
          compareRange.setPointerCapture(event.pointerId);
          markCompareUsed();
          event.preventDefault();
        });

        compareRange.addEventListener('pointermove', (event) => {
          if (!isDragging) return;
          const mediaRect = media.getBoundingClientRect();
          const dragDistance = event.clientX - dragStartX;
          setReveal(dragStartReveal + (dragDistance / mediaRect.width) * 100);
        });

        const stopDragging = (event) => {
          if (!isDragging) return;
          isDragging = false;
          if (compareRange.hasPointerCapture(event.pointerId)) {
            compareRange.releasePointerCapture(event.pointerId);
          }
        };

        compareRange.addEventListener('pointerup', stopDragging);
        compareRange.addEventListener('pointercancel', stopDragging);

        compareRange.addEventListener('keydown', (event) => {
          let nextValue = currentReveal;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') nextValue -= 1;
          else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') nextValue += 1;
          else if (event.key === 'PageDown') nextValue -= 5;
          else if (event.key === 'PageUp') nextValue += 5;
          else if (event.key === 'Home') nextValue = 5;
          else if (event.key === 'End') nextValue = compareMaximum;
          else return;

          event.preventDefault();
          setReveal(nextValue);
          markCompareUsed();
        });

        window.addEventListener('resize', () => syncCompareBounds(true), { passive: true });
      }

      const patternZones = [...root.querySelectorAll('[data-room-zone]')];
      const NATURAL_W = 1672;
      const NATURAL_H = 941;
      const imagePositionRaw = root.dataset.imagePosition || 'center center';
      const alignFactor = imagePositionRaw.startsWith('left')
        ? 0
        : imagePositionRaw.startsWith('right')
          ? 1
          : 0.5;

      const positionPatternZones = () => {
        if (!media || !patternZones.length) return;
        const boxW = media.clientWidth;
        const boxH = media.clientHeight;
        if (!boxW || !boxH) return;

        const scale = Math.max(boxW / NATURAL_W, boxH / NATURAL_H);
        const renderedW = NATURAL_W * scale;
        const renderedH = NATURAL_H * scale;
        const offsetX = (boxW - renderedW) * alignFactor;
        const offsetY = (boxH - renderedH) / 2;

        patternZones.forEach((zone) => {
          const topFrac = Number(zone.dataset.topFrac || 0);
          const heightFrac = Number(zone.dataset.heightFrac || 0);
          const leftFrac = Number(zone.dataset.leftFrac || 0);
          const rightFrac = Number(zone.dataset.rightFrac || 0);
          const left = offsetX + leftFrac * renderedW;
          const right = offsetX + rightFrac * renderedW;

          zone.style.top = `${offsetY + topFrac * renderedH}px`;
          zone.style.height = `${heightFrac * renderedH}px`;
          zone.style.left = `${left}px`;
          zone.style.width = `${Math.max(0, boxW - left - right)}px`;
        });
      };

      positionPatternZones();
      window.addEventListener('resize', positionPatternZones, { passive: true });

      const likeButton = root.querySelector('[data-like-button]');
      const likeCount = root.querySelector('[data-like-count]');
      const shareButton = root.querySelector('[data-share-button]');
      const productKey = root.dataset.productKey || 'product';
      const likeStorageKey = `lz-liked-${productKey}`;
      const baseLikeCount = Number(likeCount?.textContent || 0);

      try {
        if (likeButton && likeCount && window.localStorage.getItem(likeStorageKey) === 'true') {
          likeButton.setAttribute('aria-pressed', 'true');
          likeCount.textContent = String(baseLikeCount + 1);
        }
      } catch (error) {
        // The button still works visually when browser storage is unavailable.
      }

      likeButton?.addEventListener('click', () => {
        const isLiked = likeButton.getAttribute('aria-pressed') === 'true';
        likeButton.setAttribute('aria-pressed', String(!isLiked));
        if (likeCount) likeCount.textContent = String(baseLikeCount + (isLiked ? 0 : 1));
        try {
          window.localStorage.setItem(likeStorageKey, String(!isLiked));
        } catch (error) {
          // Ignore storage restrictions.
        }
      });

      shareButton?.addEventListener('click', async () => {
        try {
          if (navigator.share) {
            await navigator.share({ title: document.title, url: window.location.href });
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(window.location.href);
          }
        } catch (error) {
          // Cancelled shares need no visible error.
        }
      });

      const detailTabs = [...root.querySelectorAll('[data-details-tab]')];
      const detailPanels = [...root.querySelectorAll('[data-details-panel]')];

      detailTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.detailsTab;
          detailTabs.forEach((item) => {
            item.setAttribute('aria-selected', String(item === tab));
          });
          detailPanels.forEach((panelItem) => {
            panelItem.hidden = panelItem.dataset.detailsPanel !== target;
          });
        });
      });

      const variantsElement = root.querySelector('[data-variants]');
      const displaysElement = root.querySelector('[data-variant-display]');
      const labelsElement = root.querySelector('[data-labels]');
      const variantInput = root.querySelector('[data-variant-id]');
      const quantityInput = root.querySelector('[data-quantity]');
      const optionInputs = [...root.querySelectorAll('[data-option-input]')];
      const priceElement = root.querySelector('[data-price]');
      const compareElement = root.querySelector('[data-compare-price]');
      const skuElement = root.querySelector('[data-product-sku]');
      const addButton = root.querySelector('[data-add-button]');
      const addLabel = root.querySelector('[data-add-label]');
      const coverageElement = root.querySelector('[data-coverage]');
      const calculatorToggle = root.querySelector('[data-calculator-toggle]');
      const calculator = root.querySelector('[data-calculator]');
      const wallWidth = root.querySelector('[data-wall-width]');
      const wallHeight = root.querySelector('[data-wall-height]');
      const calculatorResult = root.querySelector('[data-calculator-result]');
      const applyQuantity = root.querySelector('[data-apply-quantity]');

      if (!variantsElement || !displaysElement || !labelsElement) return;

      const variants = JSON.parse(variantsElement.textContent);
      const displays = JSON.parse(displaysElement.textContent);
      const labels = JSON.parse(labelsElement.textContent);
      const sizePosition = Number(root.dataset.sizeOptionPosition || 1);
      const packPosition = Number(root.dataset.packOptionPosition || 2);
      const reservePercent = Number(root.dataset.reservePercent || 10);
      let currentCoverage = 0;
      let calculatedPacks = 0;

      const selectedOptions = () => {
        const groups = [...root.querySelectorAll('[data-option-group]')];
        return groups
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((group) => group.querySelector('[data-option-input]:checked')?.value || '');
      };

      const selectedValueAtPosition = (position) => {
        return root.querySelector(
          `[data-option-group][data-option-position="${position}"] [data-option-input]:checked`
        )?.value || '';
      };

      const numbersFrom = (value) => {
        return String(value)
          .replaceAll(',', '.')
          .match(/\d+(?:\.\d+)?/g)
          ?.map(Number) || [];
      };

      const calculateCoverage = () => {
        const dimensions = numbersFrom(selectedValueAtPosition(sizePosition));
        const packNumbers = numbersFrom(selectedValueAtPosition(packPosition));
        if (dimensions.length < 2 || packNumbers.length < 1) {
          currentCoverage = 0;
          coverageElement.textContent = '—';
          return;
        }

        const widthCm = dimensions[0];
        const heightCm = dimensions[1];
        const count = packNumbers[0];
        currentCoverage = widthCm * heightCm * count / 10000;
        coverageElement.textContent = `${currentCoverage.toFixed(2).replace('.', ',')} ${labels.coverageSuffix}`;
      };

      const calculatePacks = () => {
        const width = Number(wallWidth?.value || 0);
        const height = Number(wallHeight?.value || 0);
        if (!width || !height || !currentCoverage) {
          calculatedPacks = 0;
          calculatorResult.textContent = '—';
          applyQuantity.disabled = true;
          return;
        }

        const wallArea = width * height / 10000;
        calculatedPacks = Math.ceil((wallArea / currentCoverage) * (1 + reservePercent / 100));
        calculatorResult.textContent = `${calculatedPacks} ${labels.packsSuffix}`;
        applyQuantity.disabled = false;
      };

      const updateVariant = () => {
        const options = selectedOptions();
        const variant = variants.find((item) => {
          return item.options.every((value, index) => value === options[index]);
        });

        calculateCoverage();
        calculatePacks();

        if (!variant) {
          addButton.disabled = true;
          addLabel.textContent = labels.soldOut;
          return;
        }

        const display = displays.find((item) => String(item.id) === String(variant.id));
        variantInput.value = variant.id;
        priceElement.textContent = display?.price || '';
        if (skuElement) skuElement.textContent = display?.sku || '';
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? labels.add : labels.soldOut;

        if (display?.compare) {
          compareElement.textContent = display.compare;
          compareElement.hidden = false;
        } else {
          compareElement.textContent = '';
          compareElement.hidden = true;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        root.dispatchEvent(new CustomEvent('lz:variant-change', {
          bubbles: true,
          detail: { variant }
        }));
      };

      optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

      calculatorToggle?.addEventListener('click', () => {
        const isOpen = calculatorToggle.getAttribute('aria-expanded') === 'true';
        calculatorToggle.setAttribute('aria-expanded', String(!isOpen));
        calculator.hidden = isOpen;
        if (!isOpen) wallWidth?.focus();
      });

      wallWidth?.addEventListener('input', calculatePacks);
      wallHeight?.addEventListener('input', calculatePacks);

      applyQuantity?.addEventListener('click', () => {
        if (!calculatedPacks) return;
        quantityInput.value = calculatedPacks;
        applyQuantity.textContent = `${calculatedPacks} ${labels.packsSuffix} ✓`;
      });

      calculateCoverage();
      calculatePacks();
    };

    document.querySelectorAll('[data-lz-sticker-hero]').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-lz-sticker-hero]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-visualizer-async"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVisualizer = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-wv-dialog]');
      const openButton = root.querySelector('[data-wv-open]');
      const closeButton = root.querySelector('[data-wv-close]');
      const backButton = root.querySelector('[data-wv-back]');
      const fileInput = root.querySelector('[data-wv-file]');
      const uploadScreen = root.querySelector('[data-wv-screen="upload"]');
      const editorScreen = root.querySelector('[data-wv-screen="editor"]');
      const errorBox = root.querySelector('[data-wv-error]');
      const editorHelp = root.querySelector('[data-wv-editor-help]');
      const resultImage = root.querySelector('[data-wv-result]');
      const loading = root.querySelector('[data-wv-loading]');
      const loadingMessage = root.querySelector('[data-wv-loading-message]');
      const loadingBar = root.querySelector('[data-wv-loading-bar]');
      const loadingPercent = root.querySelector('[data-wv-loading-percent]');
      const opacityInput = root.querySelector('[data-wv-opacity]');
      const opacityOutput = root.querySelector('[data-wv-opacity-output]');
      const blendInput = root.querySelector('[data-wv-blend]');
      const downloadButton = root.querySelector('[data-wv-download]');
      const orderButton = root.querySelector('[data-wv-order]');
      const newButton = root.querySelector('[data-wv-new]');
      const shareButton = root.querySelector('[data-wv-share]');

      const state = {
        resultUrl: '',
        previewUrl: '',
        progress: 8,
        progressTimer: null,
        messageTimer: null,
        jobToken: 0,
        fileName: `visualization-${root.dataset.downloadName || 'wallpaper'}.png`
      };

      const loadingMessages = [
        'Качваме снимката…',
        'AI открива най-подходящата стена…',
        'Поставяме избрания фототапет…',
        'Запазваме мебелите и естествените сенки…',
        'Още малко — финализираме визуализацията…'
      ];

      const setError = (message = '') => {
        errorBox.textContent = message;
        errorBox.hidden = !message;
      };

      const setScreen = (name) => {
        const isEditor = name === 'editor';
        uploadScreen.hidden = isEditor;
        editorScreen.hidden = !isEditor;
        backButton.hidden = !isEditor;
      };

      const updateProgress = (value) => {
        state.progress = Math.min(100, Math.max(0, Math.round(value)));
        loadingBar.style.width = `${state.progress}%`;
        loadingPercent.textContent = `${state.progress}%`;
      };

      const startLoading = (file) => {
        window.clearInterval(state.progressTimer);
        window.clearInterval(state.messageTimer);

        if (state.previewUrl) URL.revokeObjectURL(state.previewUrl);
        state.previewUrl = URL.createObjectURL(file);
        resultImage.src = state.previewUrl;
        resultImage.hidden = false;
        state.resultUrl = '';

        let messageIndex = 0;
        loadingMessage.textContent = loadingMessages[messageIndex];
        updateProgress(8);
        loading.hidden = false;
        downloadButton.disabled = true;
        shareButton.disabled = true;

        state.messageTimer = window.setInterval(() => {
          messageIndex = Math.min(messageIndex + 1, loadingMessages.length - 1);
          loadingMessage.textContent = loadingMessages[messageIndex];
        }, 8500);

        state.progressTimer = window.setInterval(() => {
          const step = state.progress < 45 ? 5 : state.progress < 72 ? 3 : state.progress < 88 ? 1 : 0;
          updateProgress(Math.min(92, state.progress + step));
        }, 1400);
      };

      const stopLoading = (completed) => {
        window.clearInterval(state.progressTimer);
        window.clearInterval(state.messageTimer);
        state.progressTimer = null;
        state.messageTimer = null;

        if (completed) {
          loadingMessage.textContent = 'Готово! Показваме вашата визуализация.';
          updateProgress(100);
          window.setTimeout(() => {
            loading.hidden = true;
          }, 650);
          downloadButton.disabled = false;
          shareButton.disabled = false;
        } else {
          loading.hidden = true;
          if (state.previewUrl) {
            URL.revokeObjectURL(state.previewUrl);
            state.previewUrl = '';
          }
          resultImage.removeAttribute('src');
          resultImage.hidden = true;
        }
      };

      const openDialog = () => {
        setError('');
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.documentElement.style.overflow = 'hidden';
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        document.documentElement.style.overflow = '';
      };

      const loadWallpaper = async () => {
        const url = root.dataset.wallpaperUrl;
        if (!url) return;
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = url;
        try {
          await image.decode();
          state.wallpaper = image;
          if (state.room) render();
        } catch (error) {
          setError('Изображението на фототапета не можа да се зареди.');
        }
      };

      const detectWall = async (file) => {
        const endpoint = (root.dataset.wallDetectionUrl || '').trim();
        if (!endpoint) return false;

        const body = new FormData();
        body.append('room', file, file.name || 'room.jpg');
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 55000);

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            body,
            signal: controller.signal
          });
          const result = await response.json();

          if (!response.ok || !result.ok || !result.detected || !Array.isArray(result.points) || result.points.length !== 4) {
            return false;
          }

          const expectedOrder = ['top_left', 'top_right', 'bottom_right', 'bottom_left'];
          const valid = result.points.every((point, index) => {
            return point.name === expectedOrder[index]
              && Number.isFinite(point.x)
              && Number.isFinite(point.y)
              && point.x >= 0
              && point.x <= 1
              && point.y >= 0
              && point.y <= 1;
          });

          if (!valid) return false;

          state.points = result.points.map((point) => ({
            x: point.x * canvas.width,
            y: point.y * canvas.height
          }));
          return true;
        } catch (error) {
          return false;
        } finally {
          window.clearTimeout(timeout);
        }
      };

      const loadRoom = async (file) => {
        if (!file || !file.type.startsWith('image/')) {
          setError('Моля, изберете JPG, PNG или WEBP изображение.');
          return;
        }

        if (file.size > 8 * 1024 * 1024) {
          setError('Снимката трябва да бъде по-малка от 8 MB.');
          return;
        }

        const endpoint = (root.dataset.visualizationUrl || '').trim();
        const wallpaperUrl = (root.dataset.wallpaperUrl || '').trim();

        if (!endpoint) {
          setError('Добавете Production URL от n8n в настройките на секцията.');
          return;
        }

        if (!wallpaperUrl) {
          setError('Липсва изображение на фототапета в продуктовия метафийлд.');
          return;
        }

        setError('');
        setScreen('editor');
        startLoading(file);
        editorHelp.textContent = 'Подготвяме визуализацията специално за вас. Моля, изчакайте още малко.';

        const body = new FormData();
        body.append('room', file, file.name || 'room.jpg');
        body.append('wallpaper_url', wallpaperUrl);
        const statusEndpoint = `${endpoint.replace(/\/+$/, '')}-status`;
        const jobToken = ++state.jobToken;
        let completed = false;

        const wait = (milliseconds) => new Promise((resolve) => {
          window.setTimeout(resolve, milliseconds);
        });

        const readJson = async (response) => {
          const text = await response.text();
          if (!text.trim()) {
            throw new Error('Сървърът не върна отговор. Моля, опитайте отново.');
          }

          try {
            return JSON.parse(text);
          } catch (error) {
            throw new Error('Сървърът върна невалиден отговор. Моля, опитайте отново.');
          }
        };

        try {
          const startController = new AbortController();
          const startTimeout = window.setTimeout(() => startController.abort(), 45000);
          let response;

          try {
            response = await fetch(endpoint, {
              method: 'POST',
              body,
              signal: startController.signal,
              cache: 'no-store'
            });
          } finally {
            window.clearTimeout(startTimeout);
          }

          const startResult = await readJson(response);
          if (!response.ok || !startResult.ok || !startResult.job_id) {
            throw new Error(startResult.error || 'Визуализацията не можа да бъде стартирана.');
          }

          const deadline = Date.now() + 5 * 60 * 1000;
          let pollDelay = Math.max(2000, Number(startResult.poll_after_ms) || 3000);
          let result = null;

          while (Date.now() < deadline) {
            if (jobToken !== state.jobToken) {
              throw new DOMException('Заявката беше заменена.', 'AbortError');
            }

            await wait(pollDelay);

            const statusController = new AbortController();
            const statusTimeout = window.setTimeout(() => statusController.abort(), 25000);
            let statusResponse;

            try {
              statusResponse = await fetch(`${statusEndpoint}?id=${encodeURIComponent(startResult.job_id)}`, {
                method: 'GET',
                signal: statusController.signal,
                cache: 'no-store'
              });
            } catch (error) {
              if (error.name === 'AbortError') {
                continue;
              }
              throw error;
            } finally {
              window.clearTimeout(statusTimeout);
            }

            const statusResult = await readJson(statusResponse);
            if (!statusResponse.ok || !statusResult.ok) {
              throw new Error(statusResult.error || 'Визуализацията не можа да бъде завършена.');
            }

            if (statusResult.status === 'completed' && statusResult.image) {
              result = statusResult;
              break;
            }

            if (['failed', 'cancelled', 'incomplete'].includes(statusResult.status)) {
              throw new Error(statusResult.error || 'Визуализацията не можа да бъде завършена.');
            }

            pollDelay = Math.max(2000, Math.min(8000, Number(statusResult.poll_after_ms) || pollDelay));
            updateProgress(Math.min(96, state.progress + 1));
          }

          if (!result?.image) {
            throw new DOMException('Визуализацията отне твърде дълго.', 'AbortError');
          }

          state.resultUrl = result.image;
          resultImage.src = result.image;
          await resultImage.decode();
          resultImage.hidden = false;
          completed = true;
          if (state.previewUrl) {
            URL.revokeObjectURL(state.previewUrl);
            state.previewUrl = '';
          }
          editorHelp.textContent = 'Готово — фототапетът е поставен върху стената и мебелите са запазени отпред.';
        } catch (error) {
          setScreen('upload');
          setError(error.name === 'AbortError'
            ? 'Визуализацията отне твърде дълго. Опитайте отново.'
            : error.message || 'Възникна грешка при създаването на визуализацията.');
        } finally {
          stopLoading(completed);
        }
      };

      const resetPoints = () => {
        const width = canvas.width;
        const height = canvas.height;
        state.points = [
          { x: width * 0.13, y: height * 0.15 },
          { x: width * 0.87, y: height * 0.15 },
          { x: width * 0.87, y: height * 0.82 },
          { x: width * 0.13, y: height * 0.82 }
        ];
      };

      const quadPoint = (u, v) => {
        const topLeft = state.points[0];
        const topRight = state.points[1];
        const bottomRight = state.points[2];
        const bottomLeft = state.points[3];
        return {
          x: (1 - u) * (1 - v) * topLeft.x + u * (1 - v) * topRight.x + u * v * bottomRight.x + (1 - u) * v * bottomLeft.x,
          y: (1 - u) * (1 - v) * topLeft.y + u * (1 - v) * topRight.y + u * v * bottomRight.y + (1 - u) * v * bottomLeft.y
        };
      };

      const drawTriangle = (image, source, destination) => {
        const [s0, s1, s2] = source;
        const [d0, d1, d2] = destination;
        const denominator = s0.x * (s1.y - s2.y) + s1.x * (s2.y - s0.y) + s2.x * (s0.y - s1.y);
        if (Math.abs(denominator) < 0.00001) return;

        const a = (d0.x * (s1.y - s2.y) + d1.x * (s2.y - s0.y) + d2.x * (s0.y - s1.y)) / denominator;
        const b = (d0.y * (s1.y - s2.y) + d1.y * (s2.y - s0.y) + d2.y * (s0.y - s1.y)) / denominator;
        const c = (d0.x * (s2.x - s1.x) + d1.x * (s0.x - s2.x) + d2.x * (s1.x - s0.x)) / denominator;
        const d = (d0.y * (s2.x - s1.x) + d1.y * (s0.x - s2.x) + d2.y * (s1.x - s0.x)) / denominator;
        const e = (d0.x * (s1.x * s2.y - s2.x * s1.y) + d1.x * (s2.x * s0.y - s0.x * s2.y) + d2.x * (s0.x * s1.y - s1.x * s0.y)) / denominator;
        const f = (d0.y * (s1.x * s2.y - s2.x * s1.y) + d1.y * (s2.x * s0.y - s0.x * s2.y) + d2.y * (s0.x * s1.y - s1.x * s0.y)) / denominator;

        context.save();
        context.beginPath();
        context.moveTo(d0.x, d0.y);
        context.lineTo(d1.x, d1.y);
        context.lineTo(d2.x, d2.y);
        context.closePath();
        context.clip();
        context.setTransform(a, b, c, d, e, f);
        context.drawImage(image, 0, 0);
        context.restore();
      };

      const drawWallpaper = () => {
        if (!state.wallpaper || state.points.length !== 4) return;
        const columns = 18;
        const rows = 18;
        const sourceWidth = state.wallpaper.naturalWidth || state.wallpaper.width;
        const sourceHeight = state.wallpaper.naturalHeight || state.wallpaper.height;

        context.save();
        context.globalAlpha = state.opacity;
        context.globalCompositeOperation = state.blend ? 'multiply' : 'source-over';
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';

        for (let row = 0; row < rows; row += 1) {
          for (let column = 0; column < columns; column += 1) {
            const u0 = column / columns;
            const u1 = (column + 1) / columns;
            const v0 = row / rows;
            const v1 = (row + 1) / rows;
            const s00 = { x: u0 * sourceWidth, y: v0 * sourceHeight };
            const s10 = { x: u1 * sourceWidth, y: v0 * sourceHeight };
            const s11 = { x: u1 * sourceWidth, y: v1 * sourceHeight };
            const s01 = { x: u0 * sourceWidth, y: v1 * sourceHeight };
            const d00 = quadPoint(u0, v0);
            const d10 = quadPoint(u1, v0);
            const d11 = quadPoint(u1, v1);
            const d01 = quadPoint(u0, v1);

            drawTriangle(state.wallpaper, [s00, s10, s01], [d00, d10, d01]);
            drawTriangle(state.wallpaper, [s10, s11, s01], [d10, d11, d01]);
          }
        }

        context.restore();
      };

      const render = () => {
        if (!state.room || !canvas.width || !canvas.height) return;
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.globalAlpha = 1;
        context.globalCompositeOperation = 'source-over';
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(state.room, 0, 0, canvas.width, canvas.height);
        drawWallpaper();
      };

      const canvasBlob = async () => {
        if (!state.resultUrl) return null;
        const response = await fetch(state.resultUrl);
        return response.blob();
      };

      const downloadBlob = (blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = state.fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      };

      openButton?.addEventListener('click', openDialog);
      closeButton?.addEventListener('click', closeDialog);
      backButton?.addEventListener('click', () => setScreen('upload'));

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      fileInput.addEventListener('change', () => {
        const [file] = fileInput.files;
        if (file) loadRoom(file);
      });

      opacityInput?.addEventListener('input', () => {
        state.opacity = Number(opacityInput.value) / 100;
        opacityOutput.value = `${opacityInput.value}%`;
        opacityOutput.textContent = `${opacityInput.value}%`;
        render();
      });

      blendInput?.addEventListener('change', () => {
        state.blend = blendInput.checked;
        render();
      });

      newButton.addEventListener('click', () => {
        fileInput.value = '';
        setScreen('upload');
        fileInput.click();
      });

      downloadButton.addEventListener('click', async () => {
        downloadBlob(await canvasBlob());
      });

      shareButton.addEventListener('click', async () => {
        const blob = await canvasBlob();
        if (!blob) return;
        const file = new File([blob], state.fileName, { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({ files: [file], title: 'Моят фототапет' });
          } catch (error) {
            if (error.name !== 'AbortError') downloadBlob(blob);
          }
        } else {
          downloadBlob(blob);
        }
      });

      orderButton.addEventListener('click', () => {
        closeDialog();
        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const submitButton = productForm.querySelector('[type="submit"]');
          if (submitButton) setTimeout(() => submitButton.focus({ preventScroll: true }), 500);
        }
      });

    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-wall-visualizer]').forEach(initVisualizer);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-visualizer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVisualizer = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-wv-dialog]');
      const openButtons = document.querySelectorAll('[data-wv-open]');
      const closeButton = root.querySelector('[data-wv-close]');
      const backButton = root.querySelector('[data-wv-back]');
      const fileInput = root.querySelector('[data-wv-file]');
      const uploadScreen = root.querySelector('[data-wv-screen="upload"]');
      const editorScreen = root.querySelector('[data-wv-screen="editor"]');
      const errorBox = root.querySelector('[data-wv-error]');
      const editorHelp = root.querySelector('[data-wv-editor-help]');
      const resultImage = root.querySelector('[data-wv-result]');
      const loading = root.querySelector('[data-wv-loading]');
      const loadingMessage = root.querySelector('[data-wv-loading-message]');
      const loadingBar = root.querySelector('[data-wv-loading-bar]');
      const loadingPercent = root.querySelector('[data-wv-loading-percent]');
      const opacityInput = root.querySelector('[data-wv-opacity]');
      const opacityOutput = root.querySelector('[data-wv-opacity-output]');
      const blendInput = root.querySelector('[data-wv-blend]');
      const downloadButton = root.querySelector('[data-wv-download]');
      const orderButton = root.querySelector('[data-wv-order]');
      const newButton = root.querySelector('[data-wv-new]');
      const shareButton = root.querySelector('[data-wv-share]');

      const state = {
        resultUrl: '',
        previewUrl: '',
        progress: 8,
        progressTimer: null,
        messageTimer: null,
        fileName: `visualization-${root.dataset.downloadName || 'wallpaper'}.webp`
      };

      const loadingMessages = [
        'Качваме снимката…',
        'AI открива най-подходящата стена…',
        'Поставяме избрания фототапет…',
        'Запазваме мебелите и естествените сенки…',
        'Още малко — финализираме визуализацията…'
      ];

      const setError = (message = '') => {
        errorBox.textContent = message;
        errorBox.hidden = !message;
      };

      const setScreen = (name) => {
        const isEditor = name === 'editor';
        uploadScreen.hidden = isEditor;
        editorScreen.hidden = !isEditor;
        backButton.hidden = !isEditor;
      };

      const updateProgress = (value) => {
        state.progress = Math.min(100, Math.max(0, Math.round(value)));
        loadingBar.style.width = `${state.progress}%`;
        loadingPercent.textContent = `${state.progress}%`;
      };

      const startLoading = (file) => {
        window.clearInterval(state.progressTimer);
        window.clearInterval(state.messageTimer);

        if (state.previewUrl) URL.revokeObjectURL(state.previewUrl);
        state.previewUrl = URL.createObjectURL(file);
        resultImage.src = state.previewUrl;
        resultImage.hidden = false;
        state.resultUrl = '';

        let messageIndex = 0;
        loadingMessage.textContent = loadingMessages[messageIndex];
        updateProgress(8);
        loading.hidden = false;
        downloadButton.disabled = true;
        shareButton.disabled = true;

        state.messageTimer = window.setInterval(() => {
          messageIndex = Math.min(messageIndex + 1, loadingMessages.length - 1);
          loadingMessage.textContent = loadingMessages[messageIndex];
        }, 8500);

        state.progressTimer = window.setInterval(() => {
          const step = state.progress < 45 ? 5 : state.progress < 72 ? 3 : state.progress < 88 ? 1 : 0;
          updateProgress(Math.min(92, state.progress + step));
        }, 1400);
      };

      const stopLoading = (completed) => {
        window.clearInterval(state.progressTimer);
        window.clearInterval(state.messageTimer);
        state.progressTimer = null;
        state.messageTimer = null;

        if (completed) {
          loadingMessage.textContent = 'Готово! Показваме вашата визуализация.';
          updateProgress(100);
          window.setTimeout(() => {
            loading.hidden = true;
          }, 650);
          downloadButton.disabled = false;
          shareButton.disabled = false;
        } else {
          loading.hidden = true;
          if (state.previewUrl) {
            URL.revokeObjectURL(state.previewUrl);
            state.previewUrl = '';
          }
          resultImage.removeAttribute('src');
          resultImage.hidden = true;
        }
      };

      const openDialog = () => {
        setError('');
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        document.documentElement.style.overflow = 'hidden';
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        document.documentElement.style.overflow = '';
      };

      const loadWallpaper = async () => {
        const url = root.dataset.wallpaperUrl;
        if (!url) return;
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = url;
        try {
          await image.decode();
          state.wallpaper = image;
          if (state.room) render();
        } catch (error) {
          setError('Изображението на фототапета не можа да се зареди.');
        }
      };

      const detectWall = async (file) => {
        const endpoint = (root.dataset.wallDetectionUrl || '').trim();
        if (!endpoint) return false;

        const body = new FormData();
        body.append('room', file, file.name || 'room.jpg');
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 55000);

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            body,
            signal: controller.signal
          });
          const result = await response.json();

          if (!response.ok || !result.ok || !result.detected || !Array.isArray(result.points) || result.points.length !== 4) {
            return false;
          }

          const expectedOrder = ['top_left', 'top_right', 'bottom_right', 'bottom_left'];
          const valid = result.points.every((point, index) => {
            return point.name === expectedOrder[index]
              && Number.isFinite(point.x)
              && Number.isFinite(point.y)
              && point.x >= 0
              && point.x <= 1
              && point.y >= 0
              && point.y <= 1;
          });

          if (!valid) return false;

          state.points = result.points.map((point) => ({
            x: point.x * canvas.width,
            y: point.y * canvas.height
          }));
          return true;
        } catch (error) {
          return false;
        } finally {
          window.clearTimeout(timeout);
        }
      };

      const loadRoom = async (file) => {
        if (!file || !file.type.startsWith('image/')) {
          setError('Моля, изберете JPG, PNG или WEBP изображение.');
          return;
        }

        if (file.size > 8 * 1024 * 1024) {
          setError('Снимката трябва да бъде по-малка от 8 MB.');
          return;
        }

        const endpoint = (root.dataset.visualizationUrl || '').trim();
        const wallpaperUrl = (root.dataset.wallpaperUrl || '').trim();

        if (!endpoint) {
          setError('Добавете Production URL от n8n в настройките на секцията.');
          return;
        }

        if (!wallpaperUrl) {
          setError('Липсва изображение на фототапета в продуктовия метафийлд.');
          return;
        }

        setError('');
        setScreen('editor');
        startLoading(file);
        editorHelp.textContent = 'Подготвяме визуализацията специално за вас. Моля, изчакайте още малко.';

        const body = new FormData();
        body.append('room', file, file.name || 'room.jpg');
        body.append('wallpaper_url', wallpaperUrl);
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 210000);
        let completed = false;

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            body,
            signal: controller.signal
          });
          const result = await response.json();

          if (!response.ok || !result.ok || !result.image) {
            throw new Error(result.error || 'Визуализацията не можа да бъде създадена.');
          }

          state.resultUrl = result.image;
          resultImage.src = result.image;
          await resultImage.decode();
          resultImage.hidden = false;
          completed = true;
          if (state.previewUrl) {
            URL.revokeObjectURL(state.previewUrl);
            state.previewUrl = '';
          }
          editorHelp.textContent = 'Готово — фототапетът е поставен върху стената и мебелите са запазени отпред.';
        } catch (error) {
          setScreen('upload');
          setError(error.name === 'AbortError'
            ? 'Визуализацията отне твърде дълго. Опитайте отново.'
            : error.message || 'Възникна грешка при създаването на визуализацията.');
        } finally {
          window.clearTimeout(timeout);
          stopLoading(completed);
        }
      };

      const resetPoints = () => {
        const width = canvas.width;
        const height = canvas.height;
        state.points = [
          { x: width * 0.13, y: height * 0.15 },
          { x: width * 0.87, y: height * 0.15 },
          { x: width * 0.87, y: height * 0.82 },
          { x: width * 0.13, y: height * 0.82 }
        ];
      };

      const quadPoint = (u, v) => {
        const topLeft = state.points[0];
        const topRight = state.points[1];
        const bottomRight = state.points[2];
        const bottomLeft = state.points[3];
        return {
          x: (1 - u) * (1 - v) * topLeft.x + u * (1 - v) * topRight.x + u * v * bottomRight.x + (1 - u) * v * bottomLeft.x,
          y: (1 - u) * (1 - v) * topLeft.y + u * (1 - v) * topRight.y + u * v * bottomRight.y + (1 - u) * v * bottomLeft.y
        };
      };

      const drawTriangle = (image, source, destination) => {
        const [s0, s1, s2] = source;
        const [d0, d1, d2] = destination;
        const denominator = s0.x * (s1.y - s2.y) + s1.x * (s2.y - s0.y) + s2.x * (s0.y - s1.y);
        if (Math.abs(denominator) < 0.00001) return;

        const a = (d0.x * (s1.y - s2.y) + d1.x * (s2.y - s0.y) + d2.x * (s0.y - s1.y)) / denominator;
        const b = (d0.y * (s1.y - s2.y) + d1.y * (s2.y - s0.y) + d2.y * (s0.y - s1.y)) / denominator;
        const c = (d0.x * (s2.x - s1.x) + d1.x * (s0.x - s2.x) + d2.x * (s1.x - s0.x)) / denominator;
        const d = (d0.y * (s2.x - s1.x) + d1.y * (s0.x - s2.x) + d2.y * (s1.x - s0.x)) / denominator;
        const e = (d0.x * (s1.x * s2.y - s2.x * s1.y) + d1.x * (s2.x * s0.y - s0.x * s2.y) + d2.x * (s0.x * s1.y - s1.x * s0.y)) / denominator;
        const f = (d0.y * (s1.x * s2.y - s2.x * s1.y) + d1.y * (s2.x * s0.y - s0.x * s2.y) + d2.y * (s0.x * s1.y - s1.x * s0.y)) / denominator;

        context.save();
        context.beginPath();
        context.moveTo(d0.x, d0.y);
        context.lineTo(d1.x, d1.y);
        context.lineTo(d2.x, d2.y);
        context.closePath();
        context.clip();
        context.setTransform(a, b, c, d, e, f);
        context.drawImage(image, 0, 0);
        context.restore();
      };

      const drawWallpaper = () => {
        if (!state.wallpaper || state.points.length !== 4) return;
        const columns = 18;
        const rows = 18;
        const sourceWidth = state.wallpaper.naturalWidth || state.wallpaper.width;
        const sourceHeight = state.wallpaper.naturalHeight || state.wallpaper.height;

        context.save();
        context.globalAlpha = state.opacity;
        context.globalCompositeOperation = state.blend ? 'multiply' : 'source-over';
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';

        for (let row = 0; row < rows; row += 1) {
          for (let column = 0; column < columns; column += 1) {
            const u0 = column / columns;
            const u1 = (column + 1) / columns;
            const v0 = row / rows;
            const v1 = (row + 1) / rows;
            const s00 = { x: u0 * sourceWidth, y: v0 * sourceHeight };
            const s10 = { x: u1 * sourceWidth, y: v0 * sourceHeight };
            const s11 = { x: u1 * sourceWidth, y: v1 * sourceHeight };
            const s01 = { x: u0 * sourceWidth, y: v1 * sourceHeight };
            const d00 = quadPoint(u0, v0);
            const d10 = quadPoint(u1, v0);
            const d11 = quadPoint(u1, v1);
            const d01 = quadPoint(u0, v1);

            drawTriangle(state.wallpaper, [s00, s10, s01], [d00, d10, d01]);
            drawTriangle(state.wallpaper, [s10, s11, s01], [d10, d11, d01]);
          }
        }

        context.restore();
      };

      const render = () => {
        if (!state.room || !canvas.width || !canvas.height) return;
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.globalAlpha = 1;
        context.globalCompositeOperation = 'source-over';
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(state.room, 0, 0, canvas.width, canvas.height);
        drawWallpaper();
      };

      const canvasBlob = async () => {
        if (!state.resultUrl) return null;
        const response = await fetch(state.resultUrl);
        return response.blob();
      };

      const downloadBlob = (blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = state.fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      };

      openButtons.forEach((btn) => btn.addEventListener('click', openDialog));
      closeButton?.addEventListener('click', closeDialog);

      // ?visualizer=1 в адреса (напр. от банера на началната страница) отваря прозореца автоматично
      try {
        const params = new URLSearchParams(window.location.search);
        const canOpen = Array.prototype.some.call(openButtons, (btn) => !btn.disabled);
        if (params.get('visualizer') === '1' && canOpen && !window.__wvAutoOpened) {
          window.__wvAutoOpened = true;
          params.delete('visualizer');
          const query = params.toString();
          history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
          setTimeout(openDialog, 300);
        }
      } catch (error) {}
      backButton?.addEventListener('click', () => setScreen('upload'));

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      fileInput.addEventListener('change', () => {
        const [file] = fileInput.files;
        if (file) loadRoom(file);
      });

      opacityInput?.addEventListener('input', () => {
        state.opacity = Number(opacityInput.value) / 100;
        opacityOutput.value = `${opacityInput.value}%`;
        opacityOutput.textContent = `${opacityInput.value}%`;
        render();
      });

      blendInput?.addEventListener('change', () => {
        state.blend = blendInput.checked;
        render();
      });

      newButton.addEventListener('click', () => {
        fileInput.value = '';
        setScreen('upload');
        fileInput.click();
      });

      downloadButton.addEventListener('click', async () => {
        downloadBlob(await canvasBlob());
      });

      shareButton.addEventListener('click', async () => {
        const blob = await canvasBlob();
        if (!blob) return;
        const file = new File([blob], state.fileName, {
  type: blob.type || 'image/webp'
});
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          try {
            await navigator.share({ files: [file], title: 'Моят фототапет' });
          } catch (error) {
            if (error.name !== 'AbortError') downloadBlob(blob);
          }
        } else {
          downloadBlob(blob);
        }
      });

      orderButton.addEventListener('click', () => {
        closeDialog();
        const configTrigger = document.querySelector('[data-open-config]');
        if (configTrigger) {
          setTimeout(() => {
            configTrigger.click();
            const widthInput = document.querySelector('.uwp__modal [data-width]');
            if (widthInput) setTimeout(() => { widthInput.focus(); widthInput.select && widthInput.select(); }, 350);
          }, 50);
          return;
        }
        const sizeStep = document.querySelector('.uwp__step[data-step="1"]') || document.querySelector('[id^="WallpaperConfigurator-"]');
        if (sizeStep) {
          setTimeout(() => {
            sizeStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
            const widthInput = sizeStep.querySelector('[data-width]');
            if (widthInput) setTimeout(() => widthInput.focus({ preventScroll: true }), 500);
          }, 50);
          return;
        }
        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const submitButton = productForm.querySelector('[type="submit"]');
          if (submitButton) setTimeout(() => submitButton.focus({ preventScroll: true }), 500);
        }
      });

    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-wall-visualizer]').forEach(initVisualizer);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
